import React from 'react';
import './style.scss';
import shortid from 'shortid';
import { Form } from 'react-bootstrap';
import AddHeader from '../../../../../components/layout/header/add';
import Forms from '../../../../../components/molecules/forms';
import useAddModelConfiguration from './hooks';
import DataListHandler from '../../../../../components/layout/body/data-list-handler';
import RenderVMContainer from '../../utils/vm-container';
import Button from '../../../../../components/molecules/buttons';
import { VM_NUMBERING_OPTIONS, VM_TYPE_MODEL, yupErrorMsg } from '../../../../../components/atoms/const';
import RenderPagination from '../../../../../components/molecules/pagination';

function AddModelConfiguration() {
  const {
    formik, tray, page, addLoad, model, navigation,
  } = useAddModelConfiguration();
  return (
    <div>
      <AddHeader
        primary={{ route: '/vending-machine/model-management', title: 'Model Management' }}
        secondary={model.id?.toString() ? { route: `/vending-machine/model-management/${model.id}`, title: model.data?.model } : undefined}
        title="Add Model Configuration"
      />
      <form onSubmit={formik.handleSubmit}>
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-14 mb-4">Model Detail</div>
          <div className="row">
            <div className="col-md-8">
              <Forms.Default
                id="model"
                placeholder="Enter Model Name"
                className="mb-4"
                label="Model Name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.model && formik.touched.model}
                errorMsg={formik.errors.model}
                value={formik.values.model}
                readOnly={!!model.id?.toString()}
              />
            </div>
            <div className="col-md-4">
              <Forms.ReactSelect.Default
                id="type"
                placeholder="Choose Type"
                className="mb-4"
                isSearchable={false}
                label="Choose Type"
                options={!model.id?.toString() ? VM_TYPE_MODEL : []}
                onChange={(e) => {
                  if (e) formik.setFieldValue('type', e);
                }}
                value={formik.values.type}
                onBlur={formik.handleBlur}
                isInvalid={!!formik.errors.type && formik.touched.type}
                errorMsg={formik.errors.type}
              />
            </div>
          </div>
        </div>
        <div className="w-100 bg-stroke my-4" style={{ height: '7px' }} />
        <div className="px-4 px-xl-5">
          <div className="fw-bold fz-14 mb-4">Model Configuration</div>
          <Forms.Default
            id="configName"
            placeholder="Enter Configuration Name"
            className="mb-4"
            label="Configuration Name"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors.configName && formik.touched.configName}
            errorMsg={formik.errors.configName}
            value={formik.values.configName}
          />
          <div className="row">
            <div className="col-lg-4">
              <Forms.Default
                id="selection"
                placeholder="Enter Selection"
                className="mb-4"
                label="Selection"
                type="number"
                onChange={formik.handleChange}
                value={formik.values.selection}
              />
            </div>
            <div className="col-lg-4">
              <Forms.Default
                id="start"
                placeholder="Enter Start With"
                className="mb-4"
                label="Start"
                onChange={formik.handleChange}
                value={formik.values.start}
                disabled={!formik.values.selection || formik.values.selection === ''}
              />
            </div>
            <div className="col-lg-4">
              <Forms.ReactSelect.Default
                id="numbering"
                placeholder="Choose Numbering"
                className="mb-4"
                isSearchable={false}
                label="Choose Numbering"
                options={VM_NUMBERING_OPTIONS}
                onChange={(e) => {
                  if (e) formik.setFieldValue('numbering', e);
                }}
                value={formik.values.numbering}
                disabled={!formik.values.start || formik.values.start === '' || !formik.values.selection || formik.values.selection === ''}
              />
            </div>
          </div>
        </div>
        <div className="w-100 bg-stroke my-4" style={{ height: '7px' }} />
        <div className="px-4 px-xl-5 mb-4">
          <div className="row">
            <div className="col-lg-6 mb-lg-0 mb-4 h-100">
              <div className="configuration-model-tray-container p-4">
                <div className="fz-14 mb-2 fw-bold">Choose Tray Configuration</div>
                <div className="scrollable-content px-2 py-2">
                  <DataListHandler isData={!!tray.list && !!tray.list.length} isLoading={tray.load} isSmall>
                    <div>
                      <div style={{ height: '430px' }}>
                        {tray.list?.map((data) => (
                          <div className="row-tray my-1" key={data.id}>
                            <Form.Check
                              checked={!!formik.values.trays?.find((x) => x.id === data.id)}
                              className="mx-2"
                              type="checkbox"
                              onChange={(e) => {
                                formik.setFieldTouched('trays', true);
                                tray.handler(e, { start: data.start, id: data.id, columnCodes: data.columnCodes });
                              }}
                            />
                            {data?.columnCodes?.map((column) => (
                              <div className="card-number" key={shortid.generate()}>{column}</div>
                            ))}
                          </div>
                        ))}
                      </div>
                    </div>
                  </DataListHandler>
                  <div className={formik.values.selection === '' ? 'd-flex justify-content-center mt-4 w-100' : 'd-none'}>
                    <RenderPagination
                      currentPage={page.current}
                      setCurrentPage={page.setCurrent}
                      totalPage={tray.totalPage}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 mb-lg-0 mb-4">
              <div className="configuration-model-tray-container p-4 h-100">
                <div className="fw-bold fz-14 mb-2">Model Visualization</div>
                <div className="d-flex justify-content-center">
                  <RenderVMContainer data={tray.sorted} />
                </div>
                <div className="d-flex justify-content-center w-100">
                  <div
                    className={formik.touched.trays && !!formik.errors.trays ? 'invalidMsg mt-1' : 'd-none'}
                    style={{ maxWidth: 380, width: '100%' }}
                  >
                    <div>{typeof formik.errors.trays === 'string' ? formik.errors.trays : yupErrorMsg.MODEL_TRAY_EMPTY}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100 bg-stroke my-4" style={{ height: '7px' }} />
        <div className="d-flex justify-content-end p-4 px-xl-5">
          <div style={{ width: '200px', marginRight: '20px' }}>
            <Button.Default
              id="cancel"
              type="button"
              label="Cancel"
              size="lg"
              outline
              onClick={model.id?.toString() ? navigation.detail : navigation.landing}
            />
          </div>
          <div style={{ width: '200px' }}>
            <Button.Default
              id="submit"
              type="submit"
              label="Submit"
              size="lg"
              loading={addLoad}
            />
          </div>
        </div>
      </form>
    </div>
  );
}

export default AddModelConfiguration;
